$(() => {
  const $form = $('[data-js-waiver-form]');
  const selectors = {
    container: '[data-js-registrant-waiver]',
    scrollContainer: '[data-js-waiver-scroll-container]',
    forceScrollText: '[data-js-force-scroll-text]',
    signOffControls: '[data-js-sign-off-controls]',
    signOffAcceptInput: ':input[name*="acceptance"]',
    signOffSignatureInputContainer: '[data-js-sign-off-signature-input-container]',
    signOffSignatureInput: ':input[name*="signature"]',
  };

  /**
   * Lots of ifs, ands, and buts to see if the waiver requirements are met.
   * @returns {boolean}
   */
  function checkIfWaiverRequirementsAreMet() {
    let conditionsMet = true;
    $form
      .find(selectors.container)
      .each((index, element) => {
        const $errorContainer = $(element).find(selectors.forceScrollText);
        if ($errorContainer.length && $errorContainer.data('validate') === false) {
          conditionsMet = false;
          return false;
        }

        return true;
      });
    if (conditionsMet) {
      $form.find('button[type="submit"]').removeClass('disabled');
    } else {
      $form.find('button[type="submit"]').addClass('disabled');
    }
  }

  /**
   * Handle the scroll event of waiver container
   *
   * @param $container
   */
  function handleScrollContainer($container) {
    const $scrollContainer = $container.find(selectors.scrollContainer);
    const $forceScrollText = $container.find(selectors.forceScrollText);
    const $signOffControls = $container.find(selectors.signOffControls);

    if ($scrollContainer[0].scrollHeight === $scrollContainer.innerHeight()) {
      $forceScrollText.addClass('hidden').data('validate', true);
      $signOffControls.removeClass('hidden');
      checkIfWaiverRequirementsAreMet();
    } else if ($scrollContainer.innerHeight() < 250) {
      // If the waiver is short, force the details to show and bypass scroll to activate
      $forceScrollText.addClass('hidden').data('validate', true);
      $signOffControls.removeClass('hidden');
      checkIfWaiverRequirementsAreMet();
    } else {
      $scrollContainer.attr('tabindex', 0);
    }

    $scrollContainer.on('scroll', (event) => {
      const $this = $(event.target);
      const scrollPercentage = ((($this.scrollTop() + $this.innerHeight()) / $this[0].scrollHeight) * 100)
        .toFixed(2);
      if (scrollPercentage >= 99) {
        $forceScrollText.addClass('hidden').data('validate', true);
        $signOffControls.removeClass('hidden');
        checkIfWaiverRequirementsAreMet();
      }
    });
  }

  /**
   * Toggle the signature input container based on selected accept option
   *
   * @param event
   */
  function toggleSignatureInputContainer(event) {
    const $this = $(event.currentTarget);
    const $signOffControls = $this.closest(selectors.signOffControls);
    const $signatureInputContainer = $signOffControls.find(selectors.signOffSignatureInputContainer);

    if (parseInt($this.val(), 10) === 1) {
      $signatureInputContainer.removeClass('hidden').find(selectors.signOffSignatureInput).attr('required', true);
    } else {
      $signatureInputContainer.addClass('hidden').find(selectors.signOffSignatureInput).attr('required', false);
    }
  }

  /**
   * Tell Google that the waiver was accepted
   */
  const submit = (event) => {
    if (!event.currentTarget.checkValidity()) {
      return;
    }

    window.dataLayer.push({
      event: 'waiver_accepted',
    });
  };

  /**
   * Initialize listeners and properties
   */
  function initialize() {
    if (!$form.length) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    $form.find(selectors.container).each((index, element) => handleScrollContainer($(element)));
    $form.on('submit', submit);
    $(selectors.signOffAcceptInput).on('change', toggleSignatureInputContainer);

    checkIfWaiverRequirementsAreMet();
  }

  initialize();
});
